import { format } from '~/utils/date-fns';
import addMonths from '~/utils/date-fns/addMonths';

export default {
  start: format(new Date(), 'YYYY-MM-DD'),
  end: format(addMonths(new Date(), 6), 'YYYY-MM-DD'),
  numberOfNightsMin: 6,
  numberOfNightsMax: 14,
};
